import React from 'react'

import Icon from '../../../../components/UI/Icon'

const JobPostModalHeader = ({ job }) => {
  return (
    <div className="w-full rounded-[10px] border-[#FFCA84] bg-[#FFF5EE] border-[1px] p-[20px] pb-[32px]">
      <div className="w-full flex items-center justify-between">
        <h2 className="w-[75%] text-base text-primary-100 font-bold text-ellipsis whitespace-nowrap overflow-hidden">
          {job.job_category.name}
        </h2>

        {/* TODO */}
        {true && (
          <div className="px-[8px] py-[6px] rounded-[8px] bg-primary-button flex items-center justify-center">
            <Icon name="marketing" color="#FDFDFD" className="w-[16px] h-[16px] mr-[4px]" />

            <span className="text-xs text-[#FDFDFD] font-bold">Promoted</span>
          </div>
        )}
      </div>

      <h3 className="mt-[10px] w-full text-2xl font-bold text-primary-100">{job.job_title}</h3>
    </div>
  )
}

export default JobPostModalHeader
